module.exports = __webpack_public_path__ + "static/media/package_design_ui_plain.89762a02.svg";